import {NgModule} from '@angular/core';
import {PaginationComponent} from '../components/pagination/pagination.component';
import {StaticRedirectClickDirective} from '../directives/static-redirect-click.directive';
import {AddClickActionToLocalLinksDirective} from '../directives/add-click-action-to-local-links.directive';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';

@NgModule({
  imports: [CommonModule, RouterModule],
  providers: [],
  declarations: [PaginationComponent, StaticRedirectClickDirective, AddClickActionToLocalLinksDirective],
  bootstrap: [],
  exports: [PaginationComponent, StaticRedirectClickDirective, AddClickActionToLocalLinksDirective],
})
export class SharedCmsModule {}
